import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const BookmarkManager = ({ currentFilters, onLoadBookmark }) => {
  const [bookmarks, setBookmarks] = useState([
    {
      id: 1,
      name: 'Q1 2026 Full Analysis',
      filters: { employmentTypes: ['permanent', 'contract'], citizenship: 'all', period: 'q1-2026' },
      createdAt: '2026-01-10T14:30:00'
    },
    {
      id: 2,
      name: 'Non-Citizen Workforce',
      filters: { employmentTypes: ['permanent', 'contract', 'temporary'], citizenship: 'non-citizen', period: 'q1-2026' },
      createdAt: '2026-01-08T09:15:00'
    }
  ]);
  const [isAddingBookmark, setIsAddingBookmark] = useState(false);
  const [bookmarkName, setBookmarkName] = useState('');

  const handleSaveBookmark = () => {
    if (!bookmarkName?.trim()) return;

    const newBookmark = {
      id: Date.now(),
      name: bookmarkName,
      filters: currentFilters,
      createdAt: new Date()?.toISOString()
    };

    setBookmarks([...bookmarks, newBookmark]);
    setBookmarkName('');
    setIsAddingBookmark(false);
  };

  const handleDeleteBookmark = (id) => {
    setBookmarks(bookmarks?.filter(b => b?.id !== id));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full flex flex-col min-w-0">
      <div className="flex items-center justify-between mb-4 gap-2 flex-wrap">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <Icon name="Bookmark" size={18} color="var(--color-primary)" className="flex-shrink-0 md:w-5 md:h-5" />
          <h3 className="font-heading font-semibold text-sm md:text-base text-foreground truncate">Saved Filters</h3>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsAddingBookmark(!isAddingBookmark)}
          iconName={isAddingBookmark ? 'X' : 'Plus'}
          iconPosition="left"
          className="flex-shrink-0 whitespace-nowrap"
        >
          <span className="hidden sm:inline">{isAddingBookmark ? 'Cancel' : 'Save Current'}</span>
          <span className="sm:hidden">{isAddingBookmark ? 'Cancel' : 'Save'}</span>
        </Button>
      </div>
      {isAddingBookmark && (
        <div className="mb-4 p-3 bg-muted rounded-md">
          <Input
            type="text"
            label="Bookmark Name"
            placeholder="Enter bookmark name"
            value={bookmarkName}
            onChange={(e) => setBookmarkName(e?.target?.value)}
            className="mb-3 w-full"
          />
          <Button
            variant="default"
            size="sm"
            onClick={handleSaveBookmark}
            iconName="Save"
            iconPosition="left"
            fullWidth
            disabled={!bookmarkName?.trim()}
          >
            Save Bookmark
          </Button>
        </div>
      )}
      <div className="space-y-2 flex-1 overflow-y-auto max-h-[400px]">
        {bookmarks?.length === 0 ? (
          <div className="text-center py-6">
            <Icon name="BookmarkX" size={40} color="var(--color-muted-foreground)" className="mx-auto mb-2 md:w-12 md:h-12" />
            <p className="caption text-xs md:text-sm text-muted-foreground">No saved filters yet</p>
          </div>
        ) : (
          bookmarks?.map((bookmark) => (
            <div
              key={bookmark?.id}
              className="flex items-center justify-between p-3 bg-background border border-border rounded-md hover:bg-muted transition-smooth gap-2 min-w-0"
            >
              <div className="flex-1 min-w-0 overflow-hidden">
                <p className="font-body font-medium text-xs md:text-sm text-foreground mb-1 truncate">
                  {bookmark?.name}
                </p>
                <p className="caption text-xs text-muted-foreground truncate">
                  Saved on {formatDate(bookmark?.createdAt)}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <button
                  onClick={() => onLoadBookmark(bookmark?.filters)}
                  className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-primary/10 transition-smooth flex-shrink-0"
                  aria-label="Load bookmark"
                  title="Load this filter combination"
                >
                  <Icon name="Download" size={18} color="var(--color-primary)" />
                </button>
                <button
                  onClick={() => handleDeleteBookmark(bookmark?.id)}
                  className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-error/10 transition-smooth flex-shrink-0"
                  aria-label="Delete bookmark"
                  title="Delete this bookmark"
                >
                  <Icon name="Trash2" size={18} color="var(--color-error)" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BookmarkManager;